export default __webpack_public_path__ + "static/media/bag_card.4e15b3e5.png";